export default __webpack_public_path__ + "static/media/edit_icon.3f13fa26.svg";